import { render, staticRenderFns } from "./ItineraryStela.vue?vue&type=template&id=0a4a6162"
import script from "./ItineraryStela.vue?vue&type=script&lang=js"
export * from "./ItineraryStela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports